import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../MainPage.css';

const ContactModal = ({ isOpen, onClose }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="modal-overlay" onClick={onClose}>
                    <motion.div
                        className="modal-content glass-panel contact-modal"
                        onClick={(e) => e.stopPropagation()}
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        transition={{ type: "spring", damping: 25, stiffness: 300 }}
                    >
                        <button className="modal-close-btn" onClick={onClose}>&times;</button>

                        <div className="about-header">
                            <h2 className="about-title">Contact Me</h2>
                            <div className="about-divider"></div>
                        </div>

                        <div className="about-body">
                            <p className="contact-intro">
                                Feel free to reach out to me through any of the following platforms:
                            </p>

                            <ul className="contact-list">
                                <li>
                                    <span className="contact-label">Email:</span>
                                    <a href="mailto:joshuazhang447@gmail.com" className="contact-link">joshuazhang447@gmail.com</a>
                                </li>
                                <li>
                                    <span className="contact-label">Phone:</span>
                                    <a href="tel:+12267591840" className="contact-text">
                                        +1 (226-759-1840)
                                    </a>
                                </li>
                                <li>
                                    <span className="contact-label">GitHub:</span>
                                    <a href="https://github.com/joshuazhang447" target="_blank" rel="noopener noreferrer" className="contact-link">github.com/joshuazhang447</a>
                                </li>
                                <li>
                                    <span className="contact-label">LinkedIn:</span>
                                    <a href="https://www.linkedin.com/in/zhijun-zhang-46664732b/" target="_blank" rel="noopener noreferrer" className="contact-link">zhijun-zhang</a>
                                </li>
                                <li>
                                    <span className="contact-label">Discord:</span>
                                    <span className="contact-text">joshuaz447</span>
                                </li>
                            </ul>

                            <div className="about-footer">
                                <p className="thank-you">Looking forward to hearing from you!</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ContactModal;
